"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1265,
        'y': -373,
        'width': 528,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1265,
        'y': -310,
        'width': 528,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1265,
        'y': -255,
        'width': 528,
        'height': 42
      },
      'children': [],
      'backgrondColor': '#646464'
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': -363,
        'width': 528,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': -310,
        'width': 528,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#646464'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 1,
        'g': 1,
        'b': 1,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': -259,
        'width': 528,
        'height': 42
      },
      'children': [],
      'backgrondColor': '#646464'
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1090,
        'y': -203,
        'width': 327,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1090,
        'y': -143,
        'width': 327,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1090,
        'y': -92,
        'width': 327,
        'height': 84
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1322,
        'y': 899,
        'width': 480,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1322,
        'y': 977,
        'width': 480,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -1322,
        'y': 1032,
        'width': 480,
        'height': 63
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': 907,
        'width': 324,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': 967,
        'width': 324,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 178,
        'y': 1018,
        'width': 324,
        'height': 84
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-b[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1090,
        'y': 1053,
        'width': 327,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1090,
        'y': 1113,
        'width': 327,
        'height': 36
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 14,
      'letterSpacing': 0,
      'lineHeightPx': 21,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1090,
        'y': 1164,
        'width': 327,
        'height': 84
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  }
};
exports.default = _default;